const PARENT_TOKEN_KEY = 'PARENT_TOKEN';
const PARENT_LOGIN_REDIRECT_KEY = 'PARENT_LOGIN_REDIRECT';
const PARENT_SKIP_AUTO_LOGIN_ONCE_KEY = 'PARENT_SKIP_AUTO_LOGIN_ONCE';
const PARENT_OAUTH_QUERY_KEYS = ['code', 'state', 'type'];

export function getParentToken() {
  return localStorage.getItem(PARENT_TOKEN_KEY) || '';
}

export function setParentToken(token) {
  if (!token) {
    return;
  }
  localStorage.setItem(PARENT_TOKEN_KEY, token);
}

export function clearParentToken() {
  localStorage.removeItem(PARENT_TOKEN_KEY);
}

export function rememberParentLoginRedirect(path, force = false) {
  if (!path) {
    return;
  }
  if (!force && sessionStorage.getItem(PARENT_LOGIN_REDIRECT_KEY)) {
    return;
  }
  sessionStorage.setItem(PARENT_LOGIN_REDIRECT_KEY, path);
}

export function consumeParentLoginRedirect() {
  const redirect = sessionStorage.getItem(PARENT_LOGIN_REDIRECT_KEY) || '';
  sessionStorage.removeItem(PARENT_LOGIN_REDIRECT_KEY);
  return redirect;
}

export function getParentLoginRedirect() {
  return sessionStorage.getItem(PARENT_LOGIN_REDIRECT_KEY) || '';
}

export function markSkipParentAutoLoginOnce() {
  sessionStorage.setItem(PARENT_SKIP_AUTO_LOGIN_ONCE_KEY, '1');
}

export function hasSkipParentAutoLoginOnce() {
  return sessionStorage.getItem(PARENT_SKIP_AUTO_LOGIN_ONCE_KEY) === '1';
}

export function consumeSkipParentAutoLoginOnce() {
  const shouldSkip = sessionStorage.getItem(PARENT_SKIP_AUTO_LOGIN_ONCE_KEY) === '1';
  sessionStorage.removeItem(PARENT_SKIP_AUTO_LOGIN_ONCE_KEY);
  return shouldSkip;
}

export function clearSkipParentAutoLoginOnce() {
  sessionStorage.removeItem(PARENT_SKIP_AUTO_LOGIN_ONCE_KEY);
}

export function getParentOauthCode() {
  const match = window.location.search.match(/[?&]code=([^&]+)/);
  return match && match[1] ? decodeURIComponent(match[1]) : '';
}

function normalizeHash(targetHash = '') {
  if (!targetHash) {
    return window.location.hash || '#/login';
  }
  if (targetHash.indexOf('#') === 0) {
    return targetHash;
  }
  if (targetHash.indexOf('/') === 0) {
    return `#${targetHash}`;
  }
  return `#/${targetHash}`;
}

function buildParentCleanUrl(targetHash = '') {
  const currentUrl = new URL(window.location.href);
  PARENT_OAUTH_QUERY_KEYS.forEach((key) => {
    currentUrl.searchParams.delete(key);
  });
  currentUrl.hash = normalizeHash(targetHash);
  return currentUrl.toString();
}

export function clearParentOauthQueryInPlace(targetHash = '') {
  window.history.replaceState({}, document.title, buildParentCleanUrl(targetHash));
}

export function redirectToCleanParentLogin() {
  window.location.replace(buildParentCleanUrl('/login'));
}



// WEBPACK FOOTER //
// ./src/utils/parentAuth.js